import * as React from 'react';
import { Instant, LocalDateTime, LocalTime, ZonedDateTime } from '@js-joda/core';
import _ from 'lodash';

import { DisplayFormatsConsumer } from '@tock/coretypes';
import { getLocalTime } from './timeDisplay';
import { getShortTimeFormatter, getTimeFormatter } from '@tock/i18n';
import { logger } from '@tock/logging';

interface OwnProps {
  displayTimeAsShort?: boolean;
  localeFromProps?: string;
  timeValue?: string | LocalDateTime | LocalTime | Instant | ZonedDateTime | Date;
  zone?: string;
  showAmPm?: boolean;
}

export class DisplayTime extends React.PureComponent<OwnProps> {
  render() {
    const { timeValue, displayTimeAsShort, localeFromProps, showAmPm, zone } = this.props;

    return (
      <DisplayFormatsConsumer>
        {(currency: string, locale: string, timeZone: string) => {
          const localTime = !_.isNil(timeValue)
            ? getLocalTime(timeValue, zone || timeZone)
            : undefined;
          const finalLocale = localeFromProps || locale;

          const timeFormatter = displayTimeAsShort
            ? getShortTimeFormatter(finalLocale)
            : getTimeFormatter(finalLocale);
          if (_.isNil(localTime)) {
            logger.warn('could not determine the local time from props in DisplayTime');
            return null;
          }
          return <span>{timeFormatter.format(localTime, showAmPm)}</span>;
        }}
      </DisplayFormatsConsumer>
    );
  }
}
